// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[type=checkbox][data-v-1fb4a774] {\n    display: none;\n}\n\n/* to hide the checkbox itself */\ninput[type=checkbox]+label[data-v-1fb4a774]:before {\n    font-family: FontAwesome;\n    display: inline-block;\n    content: \"\\f096\";\n    letter-spacing: 10px;\n    font-size: 1.8em;\n    position: relative;\n    top: 4px;\n}\ninput[type=checkbox]:checked+label[data-v-1fb4a774]:before {\n    content: \"\\f046\";\n        letter-spacing: 6px;\n}\n\n\n", ""]);
// Exports
module.exports = exports;
